import { State } from 'src/types'
import { catchFace } from 'src/features/yellStory/drawer/glove/front/catchFace'
import { edges } from 'src/features/yellStory/drawer/glove/front/edge'
import { hamidashi } from 'src/features/yellStory/drawer/glove/front/hamidashi'
import { listLining } from 'src/features/yellStory/drawer/glove/front/listLining'
import { lace } from 'src/features/yellStory/drawer/glove/front/lace'
import { thumbBackOut, thumbBackWebSide } from 'src/features/yellStory/drawer/glove/front/back/thumbFinger'
import { indexBackMiddleSide, indexBackWebSide } from 'src/features/yellStory/drawer/glove/front/back/indexFinger'
import { middleBackIndexSide, middleBackRingSide } from 'src/features/yellStory/drawer/glove/front/back/middleFinger'
import { ringBackLittleSide } from 'src/features/yellStory/drawer/glove/front/back/ringFinger'
import { littleBackOut, littleBackRingSide } from 'src/features/yellStory/drawer/glove/front/back/littleFinger'
import { backLaceDrawerOfFront } from 'src/features/yellStory/drawer/common/useCanvasHelper'
import { rightLaceOfNetWebDrawer } from 'src/features/yellStory/drawer/glove/front/web/useCanvasWebFront'
import { webOfGloveFrontDrawer } from 'src/features/yellStory/drawer/glove/front/web/useCanvasWebFront'
import { engravedDrawer } from 'src/features/yellStory/drawer/common/useCanvasHelper'
import { canvasResetter } from 'src/util/canvas'

export const ysrCanvasGloveFront = (ctx: CanvasRenderingContext2D, state: State): void => {
  const { indexWebColor, indexMiddleColor, middleIndexColor, middleRingColor, ringLittleColor, littleRingColor } = fingerColors(state) // RAGは baseModelで判定
  // リセット
  canvasResetter(ctx)
  // 裏革
  listLining(ctx, state.listLiningsMaterial?.color)
  // 背面の紐
  backLaceDrawerOfFront(ctx, state.backLace?.value, state.lace?.color)
  // ウェブの描画
  webOfGloveFrontDrawer(ctx, state)
  // 捕球面
  catchFace(ctx, state.catchFace?.color)
  // 親指背面＿外側
  thumbBackOut(ctx, state.thumbOut?.color)
  // 親指背面＿ウェブ側
  const thumbBackWebSideColor = state.thumbWeb?.value === 'unselected' ? state.thumbWebAndIndexWeb?.color : state.thumbWeb?.color
  thumbBackWebSide(ctx, thumbBackWebSideColor)
  // 人差し指背面＿ウェブ側
  indexBackWebSide(ctx, indexWebColor)
  // 人差し指背面＿中指側
  indexBackMiddleSide(ctx, indexMiddleColor)
  // 中指背面＿人差し指側
  middleBackIndexSide(ctx, middleIndexColor)
  // 中指背面＿薬指側
  middleBackRingSide(ctx, middleRingColor)
  // 薬指背面＿小指側
  ringBackLittleSide(ctx, ringLittleColor)
  // 小指背面＿薬指側
  littleBackRingSide(ctx, littleRingColor)
  // 小指背面＿外側
  littleBackOut(ctx, state.littleOut?.color)
  // ハミダシ
  hamidashi(ctx, state.hamidashi?.color)
  // ヘリ革
  edges(ctx, state.edge?.color, state.lace?.color, state.stitch?.color, state?.bankLaceDirection, state?.baseModel.productNumber)
  // ネットウェブのみの革紐
  rightLaceOfNetWebDrawer(ctx, state)
  // 革紐
  lace(ctx, state.lace?.color, state?.materialPack)
  // メーカー捕球面の刻印
  engravedDrawer(ctx, state?.catchFace.value)
}

const fingerColors = (state: State) => {
  const indexWebColor = state?.indexWeb?.color
  const indexMiddleColor = state?.indexMiddle?.color
  const middleIndexColor = state?.middleIndex?.color
  const middleRingColor = state?.middleRing?.color
  const ringMiddleColor = state?.ringMiddle?.color
  const ringLittleColor = state?.ringLittle?.color
  const littleRingColor = state?.littleRing?.color
  // yellstoryで使う
  const isIntegratedIndex = state?.leatherIntegratedIndex?.value === 'atIndexFinger'
  const isIntegratedMiddle = state?.leatherIntegratedMiddle?.value === 'atMiddleFinger'
  const isIntegratedRing = state?.leatherIntegratedRing?.value === 'atRingFinger'

  // 以下は革一体形状の対応をしている
  return {
    indexWebColor,
    indexMiddleColor: isIntegratedIndex ? indexWebColor : indexMiddleColor,
    middleIndexColor,
    middleRingColor: isIntegratedMiddle ? middleIndexColor : middleRingColor,
    ringMiddleColor,
    ringLittleColor: isIntegratedRing ? ringMiddleColor : ringLittleColor,
    littleRingColor
  }
}
